"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerContact = void 0;
const common_1 = require("../../common");
const partner_contact_email_model_1 = require("./partner-contact-email.model");
const partner_contact_phone_model_1 = require("./partner-contact-phone.model");
class PartnerContact extends common_1.MongoSubDocument {
}
exports.PartnerContact = PartnerContact;
//# sourceMappingURL=partner-contact.model.js.map